import { createContext } from 'react';

type UserContextType = {
  user: User | null;
  refreshUser: Function;
};

const UserContext = createContext<UserContextType>({ user: null, refreshUser: () => {} });

export default UserContext;
